import Annotation from "./annotation";
import { setLineStyle } from "../canvasUtils";

export default class OpticDiscLine extends Annotation {
  constructor(){
    super();

    this.color = "orange";

    this.canvasSize = null;
    this.isFlipped270 = false;

    this.cScanIndex = 0;
    this.cScans = [];

    this.xPos = 0;
    this.yPos = 0;
  }

  draw(ctx) {
    if(!this.canvasSize) return;
    
    let w = this.canvasSize.w;
    let h = this.canvasSize.h;

    setLineStyle(ctx, this);
    ctx.beginPath();
    if (this.isFlipped270) {
      ctx.moveTo(0, this.xPos);
      ctx.lineTo(h, this.xPos);
    }
    else {
      ctx.moveTo(0, this.yPos);
      ctx.lineTo(w, this.yPos);
    }
    ctx.closePath();
    ctx.stroke();
  }

  updateCScanIndex(index) {
    this.cScanIndex = index;
    this.updatePos();
    this.signalReady();
  }

  updateCScans(scans) {
    this.cScans = scans;
  }

  updatePos() {
    if (this.isFlipped270)
      this.xPos = this.cScanIndex / this.cScans.length * this.canvasSize.w;
    else
      this.yPos = this.cScanIndex / this.cScans.length * this.canvasSize.h;
  }
}